import React from "react";
import { Layout, UserDetails } from "../../components";
const UserDetailsPage = () => {
  return (
    <Layout>
      <UserDetails />
    </Layout>
  );
};

export default UserDetailsPage;
